import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';

interface ChatButtonProps {
  onClick: () => void;
  unreadCount?: number;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  tooltip?: string;
}

const ChatButton: React.FC<ChatButtonProps> = ({
  onClick,
  unreadCount = 0,
  disabled = false,
  size = 'medium',
  tooltip = 'Open AI Assistant'
}) => {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          size={size}
          sx={{
            color: '#1976d2',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)'
            }
          }}
        >
          <Badge 
            badgeContent={unreadCount} 
            color="error"
            max={99}
          >
            <ChatIcon />
          </Badge>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ChatButton;